import {ErrorWrapper, ResponseWrapper} from "@/core/service/util";
import {RoomDocService} from "@/core/service/room.doc.service";

export class LmsDocService extends RoomDocService {

    isLmsRoom(room) {
        const lmsRoomTypes = [
            'grmlms',
            // 'conf'
        ];
        return lmsRoomTypes.includes(room.roomType);
    }

    async getRoomDocInfoList () {
        try {
            const response = await this.request().get(`/api/v3/lecture/${this.getRoomId()}/docs`)
            return new ResponseWrapper(response, response.data.data)
        } catch (error) {
            throw new ErrorWrapper(error)
        }
    }

    async uploadRoomDoc ({roomGroupId='default', filename, file, setRoomDoc, onUploadProgress}) {
        try {
            const data = new FormData();
            data.append('roomGroupId', roomGroupId);
            data.append('filename', filename);
            data.append('file', file);
            if(setRoomDoc) {
                data.append('setRoomDoc', setRoomDoc)
            }
            const response = await this.request().post(`/api/v3/lecture/${this.getRoomId()}/doc/files/add`, data, {
                onUploadProgress
            })
            return new ResponseWrapper(response, response.data.data)
        } catch (error) {
            throw new ErrorWrapper(error)
        }
    }

    async uploadRoomDocFileGroupList ({roomGroupIds, filename, file, setRoomDoc, onUploadProgress}) {
        try {
            const data = new FormData();
            data.append('roomGroupIds', roomGroupIds);
            data.append('filename', filename);
            data.append('file', file);
            if(setRoomDoc) {
                data.append('setRoomDoc', setRoomDoc)
            }

            const response = await this.request().post(`/api/v3/lecture/${this.getRoomId()}/doc/files/add/list`, data, {
                onUploadProgress
            })
            return new ResponseWrapper(response, response.data.data)
        } catch (error) {
            throw new ErrorWrapper(error)
        }
    }
}

export const lmsDocService = new LmsDocService()